module.exports = "\n.scroling {\n    overflow: auto !important;\n}\n@media screen and (max-width: 600px) {\n    .text-dark-red {\n        font-size: 17px;\n    }\n    .clear{\n        clear: both;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cms/home-getpaid/home-getpaid.component.css
// module id = ./src/app/cms/home-getpaid/home-getpaid.component.css
// module chunks = main